import { useContext, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { authContext } from "../../context/AuthContext.js";
import { prefetchGridLayouts } from "./useGridLayout.js";

/** Warms the shared grid-layouts query once after auth. */
export default function PrefetchGridLayouts() {
    const { isAuthenticated } = useContext(authContext) || {};
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!isAuthenticated) return;
        prefetchGridLayouts(queryClient);
    }, [isAuthenticated, queryClient]);

    return null;
}
